import { render, staticRenderFns } from "./ReferralPromotionUpdateForm.vue?vue&type=template&id=30567a69&"
import script from "./ReferralPromotionUpdateForm.vue?vue&type=script&lang=js&"
export * from "./ReferralPromotionUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports